module.exports = __webpack_public_path__ + "wheatpti_icon.png?0a6617627dfb96121103d4c09506ee57";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/wheatpti_icon.png
// module id = 221
// module chunks = 0